import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

// 충전소 리스트 갯수 제한
export const limitData = <T extends { rows: any[] }>(data: T, limit: number = 40): T => {
    return {
        ...data,
        rows: data.rows.slice(0, limit),
    };
};
